import { FaPhone } from "react-icons/fa6";
import { Button, Popover } from "flowbite-react";
function LetsCall() {
  return (
    <Popover
      aria-labelledby="default-popover"
      content={
        <div className="w-64 text-sm text-gray-500 dark:text-gray-400">
          <div className="border-b border-gray-200 bg-teal px-3 py-2 dark:border-gray-600 dark:bg-teal">
            <h3
              id="default-popover"
              className="font-bold text-gray-900 dark:text-white md:text-xl"
            >
              Volat Matěj Král?
            </h3>
          </div>
          <div className="mb-2 px-5 py-2">
            <a
              className="flex items-center hover:bg-white hover:text-green-500"
              href="tel:+420777533816"
            >
              <div className="relative h-6 w-6">
                <div className="absolute top-3 h-4 w-5">
                  <FaPhone />
                </div>
              </div>
              <p className="text-gray-500 hover:text-green-500">
                +420777533816
              </p>
            </a>
          </div>
        </div>
      }
    >
      <button>
        <div className="inline-flex h-11 items-center justify-center gap-2 rounded-lg border border-temRed px-3 py-2.5">
          <div className="relative h-6 w-6">
            <div className="absolute left-[1.86px] top-[2.17px] h-[21.65px] w-5 text-temRed">
              <FaPhone />
            </div>
          </div>
          <div className="text-temRed">Chci si zavolat</div>
        </div>
      </button>
    </Popover>
  );
}

export default LetsCall;
